<div cdkDropList [cdkDropListSortingDisabled]="!allowSort"
     class="drop-list"
     [class.item-dragging]="dragging"
     (cdkDropListDropped)="droppedIntoList($event)">
  <div class="empty-teams" *ngIf="!items?.length">
    {{emptyText}}
  </div>
  <div [cdkDragLockAxis]="listDragAxis" cdkDrag [cdkDragDisabled]="dragDisabled" class="item" *ngFor="let item of items; let index = index"
    [class.selected]="isSelected(index)" (click)="select($event, index)" (cdkDragStarted)="dragStarted($event, index)"
    (cdkDragEnded)="dragEnded()" (cdkDragDropped)="dropped($event)">
    <div *ngIf="!dragging || !isSelected(index)">
      <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: item, item: item, index: index }">
      </ng-container>
      <div *cdkDragPreview class="drag-preview">
        <div class="select-item-drag-preview float-right">
          {{ selections.length || 1 }}
        </div>
        <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: item, item: item, index: index }">
        </ng-container>
        <div class="select-multi-item-drag-preview ">
        </div>
      </div>
    </div>
  </div>
</div>
